import api from "./index";
import { ENDPOINTS } from "./endpoints";

/* ADD REVIEW */
export const addReview = (data)=>
  api.post(ENDPOINTS.BUYER_REVIEWS.ADD, data);

/* GET REVIEWS */
export const getReviews = (id)=>
  api.get(ENDPOINTS.BUYER_REVIEWS.LIST(id));